import { render, staticRenderFns } from "./WidgetEarning.vue?vue&type=template&id=311df73d&"
import script from "./WidgetEarning.vue?vue&type=script&lang=js&"
export * from "./WidgetEarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports